import { formatDate } from './../common/commonHelper';
import { Injectable } from '@angular/core';
import { Http, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import { AuthHeaderService } from '../views/authheader.service';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError as observableThrowError, throwError} from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JobService {

  joburl: string;
  dispatchUrl:string;
  ticketUrl:string;
  jobInvoiceUrl:string;
  jobActaulStatementurl:string;
  JobSalesStatementurl:string;
  getStatementJobSalesLineItemsUrl:string;
  getDeliverySummaryUrl:string;
  getDeliveryPlanUrl:string;
  downloadExcelUrl:string;
  backgroundTaskUrl:string;
  getPODsurl:string;
  updateDriverOrCarrierUrl:string;
  itemurl: string;
  writeoffurl: string;
  bulkUpdateUrl: string;
  uploadExcelUrl:string
  jobscheduleReportUrl: string;
  getDashboardJobs:string;
  jobunittypecount:string;
  jobdrivercarrierloadcount:string;
  constructor(private http: Http, private httpClient: HttpClient, private _headerService: AuthHeaderService) {
    this.joburl = environment.joburl;
    this.jobActaulStatementurl = environment.jobActaulStatementurl
    this.JobSalesStatementurl = environment.JobSalesStatement
    this.getPODsurl = environment.getPODs
    this.getDeliveryPlanUrl = environment.getDeliveryPlanUrl
    this.jobscheduleReportUrl = environment.jobScheduleReport
    this.getDeliverySummaryUrl = environment.getDeliverySummaryUrl
    this.updateDriverOrCarrierUrl = environment.updateDriverOrCarrierUrl
    this.getStatementJobSalesLineItemsUrl = environment.getStatementJobSalesLineItems
    this.downloadExcelUrl =  environment.downloadExcel
    this.uploadExcelUrl = environment.uploadExcel;
    this.backgroundTaskUrl =environment.backgroundTask;
    this.bulkUpdateUrl = environment.bulkUpdate;
    this.getDashboardJobs = environment.getDashboardJobs;
    this.jobunittypecount =  environment.jobunittypecount;
    this.jobdrivercarrierloadcount = environment.jobdrivercarrierloadcount;
    this.dispatchUrl = environment.dispatchUrl;
    this.ticketUrl = environment.ticketUrl;
    this.jobInvoiceUrl = environment.jobInvoiceUrl;
    const headersObj = this._headerService.getHeader() || {};
      this.options = {
        headers: new HttpHeaders(headersObj)
      };

    }
  options: { headers: HttpHeaders };

  getItems() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    this.itemurl = this.joburl + "/items";
    console.log("item url", this.itemurl);
    return this.http.get(this.itemurl, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobScheduleReportData(){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.jobscheduleReportUrl, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getJobScheduleReport(filterOptions?) {
    let url = this.jobscheduleReportUrl + "?";
    if (filterOptions?.jobId) {
      url = url + "jobId=" + filterOptions.jobId + '&';
    }
    if (filterOptions?.fromDate) {
      url = url + "fromDate=" + filterOptions.fromDate + '&';
    }
    if (filterOptions?.toDate) {
      url = url + "toDate=" + filterOptions.toDate + '&';
    }
    if (filterOptions?.page) {
      url = url+ "page=" + filterOptions.page + '&';
    }
    if (filterOptions?.limit) {
      url = url + "limit=" + filterOptions.limit + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }

  submitEditedData(data: any[], taskId: string): Observable<any> {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    console.log("Posting data to:", this.bulkUpdateUrl);
    console.log("data", data);
    console.log("task Id", taskId);

    return this.http.put(this.bulkUpdateUrl, { records: data, taskId: taskId }, options).pipe(
      map((response) => {
        console.log('API Response:', response);
        return response.json();
      }),
      catchError((error: Response) => {
        console.error('Error submitting data:', error);
        return observableThrowError(error);
      })
    );
  }

  SendForm(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.post(this.joburl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateJobTasks(jobId, pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.put(this.joburl + "/" + jobId + '/job-tasks' , pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  createActualForLoad(object) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.post(this.joburl + "/load/loadactuals", object, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  updateActualForLoad(object, id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.put(this.joburl + "/load/loadactuals/" + id, object, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getDeliveredLoadsActualsData(filterOptions?) {
    let url = this.joburl + "/load/loadactuals" + "?";
    if (filterOptions?.job) {
      url = url + "jobId=" + filterOptions.job + '&';
    }
    if (filterOptions?.customer) {
      url = url + "customerId=" + filterOptions.customer + '&';
    }
    if (filterOptions?.load) {
      url = url + "loadNumber=" + filterOptions.load + '&';
    }
    if (filterOptions?.loadId) {
      url = url + "loadId=" + filterOptions.loadId + '&';
    }
    if (filterOptions?.deliveryLocation) {
      url = url + "deliveryLocation=" + filterOptions.deliveryLocation?.fullAddress + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getDeliveryPlan(filterOptions?) {
    let url = this.getDeliveryPlanUrl + "?";
    if (filterOptions?.job) {
      url = url + "jobId=" + filterOptions.job + '&';
    }
    if (filterOptions?.driver) {
      url = url + "driverId=" + filterOptions.driver + '&';
    }
    if (filterOptions?.carrierId) {
      url = url + "carrierId=" + filterOptions.carrierId + '&';
    }
    if (filterOptions?.truckId) {
      url = url + "truckId=" + filterOptions.truckId + '&';
    }
    if (filterOptions?.unitType) {
      url = url + "unitTypeId=" + filterOptions.unitType + '&';
    }
    if (filterOptions?.fromDate) {
      url = url + "fromDate=" + filterOptions.fromDate + '&';
    }
    if (filterOptions?.toDate) {
      url = url + "toDate=" + filterOptions.toDate + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getDeliverySummary(filterOptions?) {
    let url = this.getDeliverySummaryUrl + "?";
    if (filterOptions?.job) {
      url = url + "jobId=" + filterOptions.job + '&';
    }
    if (filterOptions?.driver) {
      url = url + "driverId=" + filterOptions.driver + '&';
    }
    if (filterOptions?.carrierId) {
      url = url + "carrierId=" + filterOptions.carrierId + '&';
    }
    if (filterOptions?.truckId) {
      url = url + "truckId=" + filterOptions.truckId + '&';
    }
    if (filterOptions?.unitType) {
      url = url + "unitTypeId=" + filterOptions.unitType + '&';
    }
    if (filterOptions?.fromDate) {
      url = url + "fromDate=" + filterOptions.fromDate + '&';
    }
    if (filterOptions?.toDate) {
      url = url + "toDate=" + filterOptions.toDate + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobLoadActualOptimizedData(filterOptions?) {
    let url = this.joburl + "/load/getJobLoadActualOptimized" + "?";
    if (filterOptions?.job) {
      url = url + "jobId=" + filterOptions.job + '&';
    }
    if (filterOptions?.customer) {
      url = url + "customerId=" + filterOptions.customer + '&';
    }
    if (filterOptions?.load) {
      url = url + "loadNumber=" + filterOptions.load + '&';
    }
    if (filterOptions?.loadId) {
      url = url + "loadId=" + filterOptions.loadId + '&';
    }
    if (filterOptions?.fromDate) {
      url = url + "fromDate=" + filterOptions.fromDate + '&';
    }
    if (filterOptions?.toDate) {
      url = url + "toDate=" + filterOptions.toDate + '&';
    }
    if (filterOptions?.costGroup) {
      url = url + "costGroup=" + filterOptions.costGroup + '&';
    }
    if (filterOptions?.driver) {
      url = url + "driver=" + filterOptions.driver + '&';
    }
    if (filterOptions?.deliveryLocation) {
      url = url + "deliveryLocation=" + filterOptions.deliveryLocation?.fullAddress + '&';
    }
    if (filterOptions?.perPage) {
      url = url + "perPage=" + filterOptions.perPage + '&';
    }
    if (filterOptions?.page) {
      url = url + "page=" + filterOptions.page + '&';
    }
    if (filterOptions?.sortKey) {
      url = url + "sortKey=" + filterOptions.sortKey + '&';
    }
    if (filterOptions?.interplant) {
      url = url + "isInPlantCustomer=" + filterOptions.interplant + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  getJobSalesOptimized(filterOptions?) {
    let url = this.joburl + "/sales/getJobSalesOptimized" + "?";
    if (filterOptions?.job) {
      url = url + "jobId=" + filterOptions.job + '&';
    }
    if (filterOptions?.customer) {
      url = url + "customerId=" + filterOptions.customer + '&';
    }
    // if (filterOptions?.load) {
    //   url = url + "loadNumber=" + filterOptions.load + '&';
    // }
    if (filterOptions?.loadId) {
      url = url + "loadId=" + filterOptions.loadId + '&';
    }
    if (filterOptions?.fromDate) {
      url = url + "fromDate=" + filterOptions.fromDate + '&';
    }
    if (filterOptions?.toDate) {
      url = url + "toDate=" + filterOptions.toDate + '&';
    }
    if (filterOptions?.costGroup) {
      url = url + "costGroup=" + filterOptions.costGroup + '&';
    }
    if (filterOptions?.driver) {
      url = url + "driver=" + filterOptions.driver + '&';
    }
    if (filterOptions?.deliveryLocation) {
      url = url + "deliveryLocation=" + filterOptions.deliveryLocation?.fullAddress + '&';
    }
    if (filterOptions?.perPage) {
      url = url + "perPage=" + filterOptions.perPage + '&';
    }
    if (filterOptions?.page) {
      url = url + "page=" + filterOptions.page + '&';
    }
    if (filterOptions?.sortKey) {
      url = url + "sortKey=" + filterOptions.sortKey + '&';
    }
    if (filterOptions?.interplant) {
      url = url + "isInPlantCustomer=" + filterOptions.interplant + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  createInvoice(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.post(this.joburl + "/sales", pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  createJobInvoice(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.post(this.jobInvoiceUrl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  deltainvoice(pageFilters){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.post(this.joburl + "/sales/deltainvoice", pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  createCommonInvoice(payload) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.joburl + "/sales/createCommonInvoice", payload, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  cancelInvoice(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.post(this.joburl + "/sales/cancelInvoice", pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  cancelTicketInvoice(invoiceId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.post(this.jobInvoiceUrl + "/cancel/" + invoiceId, {}, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobSales(filterOptions?) {
    let url = this.joburl + "/sales" + "?";
    if (filterOptions?.job) {
      url = url + "jobId=" + filterOptions.job + '&';
    }
    if (filterOptions?.customer) {
      url = url + "customerId=" + filterOptions.customer + '&';
    }
    // if (filterOptions?.load) {
    //   url = url + "loadNumber=" + filterOptions.load + '&';
    // }
    if (filterOptions?.loadId) {
      url = url + "loadId=" + filterOptions.loadId + '&';
    }
    if (filterOptions?.deliveryLocation) {
      url = url + "deliveryLocation=" + filterOptions.deliveryLocation?.fullAddress + '&';
    }
    if(filterOptions?.populate){
      url = url + "populate=" + filterOptions.populate + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobCustomerReport(filterOptions?) {
    let url = this.joburl + "/sales/customerReport" + "?";
    if (filterOptions?.startDate) {
      url = url + "startDate=" + filterOptions.startDate + '&';
    }
    if (filterOptions?.customerId) {
      url = url + "customerId=" + filterOptions.customerId + '&';
    }
    // if (filterOptions?.load) {
    //   url = url + "loadNumber=" + filterOptions.load + '&';
    // }
    if (filterOptions?.endDate) {
      url = url + "endDate=" + filterOptions.endDate + '&';
    }
    if (filterOptions?.jobId) {
      url = url + "jobId=" + filterOptions.jobId + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  CreateLoads(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(opt+ions));
    return this.http.post(this.joburl + "/load", pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  CreateBulkLoads(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(opt+ions));
    return this.http.post(this.joburl + "/load/bulk-loads", pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateLoad(pageFilters, id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(opt+ions));
    return this.http.put(this.joburl + "/load/" + id, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoads(searchOptions?) {
    let url;
    url = this.joburl + "/load" + '?';
    if(searchOptions){
      let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
      if (searchOptions) {
        if (searchOptions["jobId"] != "" && searchOptions["jobId"] != null) {
          url = url + "jobId=" + searchOptions["jobId"] + '&';
        }
        if (searchOptions["loadStatus"] != "" && searchOptions["loadStatus"] != null) {
          url = url + "loadStatus=" + searchOptions["loadStatus"] + '&';
        }
        if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
          url = url + "customerId=" + searchOptions["customerId"] + '&';
        }
        if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
          url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
        }
        if (searchOptions["dispatcher"] != "" && searchOptions["dispatcher"] != null) {
          url = url + "dispatcher=" + searchOptions["dispatcher"] + '&';
        }
        if (searchOptions["carrier"] != "" && searchOptions["carrier"] != null) {
          url = url + "carrier=" + searchOptions["carrier"] + '&';
        }
        if (searchOptions["driver"] != "" && searchOptions["driver"] != null) {
          url = url + "driver=" + searchOptions["driver"] + '&';
        }
        if (searchOptions["truck"] != "" && searchOptions["truck"] != null) {
          url = url + "truck=" + searchOptions["truck"] + '&';
        }
        if (searchOptions["unitType"] != "" && searchOptions["unitType"] != null) {
          url = url + "unitType=" + searchOptions["unitType"] + '&';
        }
        if (searchOptions["invoiceStatus"] != "" && searchOptions["invoiceStatus"] != null) {
          url = url + "loadStatus=" + searchOptions["invoiceStatus"] + '&';
        }
        if (searchOptions["deliveryLocation"] != "" && searchOptions["deliveryLocation"] != null) {
          url = url + "deliveryLocation=" + searchOptions["deliveryLocation"]["fullAddress"] + '&';
        }
        if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
          url = url + "fromDate=" + searchOptions["fromDate"] + '&';
        }
        if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
          url = url + "toDate=" + searchOptions["toDate"] + '&';
        }
        url= url+"pageNumber="+ searchOptions["pageNumber"]+"&";
        url= url+"pageSize="+ searchOptions["pageSize"]+"&";
      }
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadsReport(searchOptions?) {
    let url;
    url = this.joburl + "/load/report" + '?';
    if(searchOptions){
      let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
      if (searchOptions) {
        if (searchOptions["jobId"] != "" && searchOptions["jobId"] != null) {
          url = url + "jobId=" + searchOptions["jobId"] + '&';
        }
        if (searchOptions["loadStatus"] != "" && searchOptions["loadStatus"] != null) {
          url = url + "loadStatus=" + searchOptions["loadStatus"] + '&';
        }
        if (searchOptions["customerId"] != "" && searchOptions["customerId"] != null) {
          url = url + "customerId=" + searchOptions["customerId"] + '&';
        }
        if (searchOptions["loadNumber"] != "" && searchOptions["loadNumber"] != null) {
          url = url + "loadNumber=" + searchOptions["loadNumber"] + '&';
        }
        if (searchOptions["dispatcher"] != "" && searchOptions["dispatcher"] != null) {
          url = url + "dispatcher=" + searchOptions["dispatcher"] + '&';
        }
        if (searchOptions["carrier"] != "" && searchOptions["carrier"] != null) {
          url = url + "carrier=" + searchOptions["carrier"] + '&';
        }
        if (searchOptions["driver"] != "" && searchOptions["driver"] != null) {
          url = url + "driver=" + searchOptions["driver"] + '&';
        }
        if (searchOptions["truck"] != "" && searchOptions["truck"] != null) {
          url = url + "truck=" + searchOptions["truck"] + '&';
        }
        if (searchOptions["unitType"] != "" && searchOptions["unitType"] != null) {
          url = url + "unitType=" + searchOptions["unitType"] + '&';
        }
        if (searchOptions["invoiceStatus"] != "" && searchOptions["invoiceStatus"] != null) {
          url = url + "loadStatus=" + searchOptions["invoiceStatus"] + '&';
        }
        if (searchOptions["deliveryLocation"] != "" && searchOptions["deliveryLocation"] != null) {
          url = url + "deliveryLocation=" + searchOptions["deliveryLocation"]["fullAddress"] + '&';
        }
        if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
          url = url + "fromDate=" + searchOptions["fromDate"] + '&';
        }
        if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
          url = url + "toDate=" + searchOptions["toDate"] + '&';
        }
        url= url+"pageNumber="+ searchOptions["pageNumber"]+"&";
        url= url+"pageSize="+ searchOptions["pageSize"]+"&";
      }
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadDataWithID(loadId) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.joburl + "/load" + "?_id=" + loadId, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobOrderData(filterOptions?: any) {
    let url = this.joburl + "?";
    if (filterOptions?.jobStatus) {
      url = url + "jobStatus=" + filterOptions.jobStatus + '&';
    }
    if (filterOptions?.job) {
      url = url + "_id=" + filterOptions.job + '&';
    }
    if (filterOptions?.customer) {
      url = url + "customerId=" + filterOptions.customer + '&';
    }
    if (filterOptions?.deliveryLocation) {
      url = url + "deliveryLocation=" + filterOptions.deliveryLocation?.fullAddress + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getLoadActualStatement(body){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post( this.jobActaulStatementurl,body, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getSalesStatement(body){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post( this.JobSalesStatementurl,body, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getStatementJobSalesLineItems(body){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post( this.getStatementJobSalesLineItemsUrl,body, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getPODs(body){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post( this.getPODsurl,body, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  sendJobForApproval(body) {
    let url = this.joburl;
    let jobapprovalurl = this.joburl + "/jobapproval";
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(jobapprovalurl,body, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getApprovedJob(envelopeId) {
    let url = this.joburl;
    let jobapprovalurl = this.joburl + "/jobapproval/"+envelopeId;
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(jobapprovalurl, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  EditJob(obj, id) {
    delete obj["_id"];
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.joburl + "/" + id, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  /* EditFactor(obj) {
    let options = new RequestOptions({ headers: this._headerService.getHeader() });
    return this.http.put(this.joburl+"/"+obj._id,obj,options).pipe(map(response=>response.json()),catchError((error:Response)=>{return observableThrowError(error);}));
    } */

  DeleteFactor(_id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.delete(this.joburl + "/" + _id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  FactorReceipt(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(JSON.stringify(options));
    return this.http.post(this.joburl + '/receipt', pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  CreateWriteoff(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(JSON.stringify(options));
    return this.http.post(this.writeoffurl, pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getWriteoffData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.writeoffurl, options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  GeneralJournal(pageFilters) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    // console.log(JSON.stringify(options));
    return this.http.post(this.joburl + '/generaljournal', pageFilters, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getFactorReceiptData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.joburl + "/receipt", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getGeneralJournalData() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.joburl + "/generaljournal", options).pipe(
      map((response) => (response.json().data ? [] : response.json())),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  getLoadCount() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.joburl + "/load/loadcounter", options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }


  manualEditJob(obj, id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.joburl + "/" + id + '/manualDeliveryUpdate', obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateLoadPlan(obj, id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.joburl + "/" + id + '/loadpaln', obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateLoadPerJob(obj, id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(this.joburl + "/" + id + '/updateLoadsByJob', obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getLoadPerJob(date, id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.joburl + "/" + id + '/getLoadsByJob/'+date, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  deliveryPlanUpdate(object) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    // console.log(JSON.stringify(options));
    return this.http.put(this.updateDriverOrCarrierUrl , object, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  cancelLoad(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.joburl + '/load/cancel', obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getJobTimeReport(searchOptions?) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    let url = this.joburl + '/timereport?';
    if(searchOptions){
      let isSearchOptionsEmpty = Object.values(searchOptions).every(x => (x === null || x === ''));
      if (searchOptions) {
        if (searchOptions["job"] != "" && searchOptions["job"] != null) {
          url = url + "jobId=" + searchOptions["job"];
        }
        if (searchOptions["driver"] != "" && searchOptions["driver"] != null) {
          url = url + "&driverId=" + searchOptions["driver"];
        }
        if (searchOptions["carrierId"] != "" && searchOptions["carrierId"] != null) {
          url = url + "&carrierId=" + searchOptions["carrierId"];
        }
        if (searchOptions["truckId"] != "" && searchOptions["truckId"] != null) {
          url = url + "&truckId=" + searchOptions["truckId"];
        }
        if (searchOptions["unitType"] != "" && searchOptions["unitType"] != null) {
          url = url + "&unitTypeId=" + searchOptions["unitType"];
        }
        if (searchOptions["fromDate"] != "" && searchOptions["fromDate"] != null) {
          url = url + "&fromDate=" + searchOptions["fromDate"];
        }
        if (searchOptions["toDate"] != "" && searchOptions["toDate"] != null) {
          url = url + "&toDate=" + searchOptions["toDate"];
        }
        url= url+"&pageNumber="+ searchOptions["pageNumber"]+"&";
        url= url+"pageSize="+ searchOptions["pageSize"]+"&";
      }
    }
    return this.http.get(url, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }
  getDeliveryExcelList() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.backgroundTaskUrl , options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }
  getDeliveryExcelById(id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.backgroundTaskUrl + '/' + id, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }
  downloadExcel(filterOptions?): Observable<any> {
    let url = this.downloadExcelUrl + "?";
    if (filterOptions?.job) {
      url = url + "jobId=" + filterOptions.job + '&';
    }
    if (filterOptions?.driver) {
      url = url + "driverId=" + filterOptions.driver + '&';
    }
    if (filterOptions?.carrierId) {
      url = url + "carrierId=" + filterOptions.carrierId + '&';
    }
    if (filterOptions?.truckId) {
      url = url + "truckId=" + filterOptions.truckId + '&';
    }
    if (filterOptions?.unitType) {
      url = url + "unitTypeId=" + filterOptions.unitType + '&';
    }
    if (filterOptions?.fromDate) {
      url = url + "fromDate=" + filterOptions.fromDate + '&';
    }
    if (filterOptions?.toDate) {
      url = url + "toDate=" + filterOptions.toDate + '&';
    }
    // let options = new RequestOptions({
    //   headers: this._headerService.getHeader(),
    // });
    return this.httpClient.get(url, {
      responseType:'blob',
      headers: {
        'token' : 'Bearer ' + localStorage.getItem('token'),
        'Authorization' : 'Bearer ' + localStorage.getItem('token'),
        "company": localStorage.getItem("selectedCompany")
      }
    })//.pipe(
    //   map((response: Blob) => {
    //     const fileName = 'downloaded-file.xlsx'; // You can make this dynamic if the API provides the filename
    //     FileSaver.saveAs(response, fileName);
    //   },
    //   error: (error) => console.error('Error downloading file', error))
    // );
  }

  async uploadExcel(formData: any) {

    var resp
    var companyId = localStorage.getItem("selectedCompany")
    await fetch(this.uploadExcelUrl,
      {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          company: companyId,
          reportProgress: "true",
          responseType: "json",
          "enable-cors": "true",
        }
      })
      .then((response) => {
        resp = response.json()
      })
      .catch((err) => {
        console.log('Error ' + err);

      })
    return resp
  }

  getJobDashboard(query?) {
    let url = this.getDashboardJobs + "?";
    if (query?.fromDate) {
      url += "fromDate=" + query.fromDate + "&";
    }
    if (query?.toDate) {
      url += "toDate=" + query.toDate + "&";
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );

  }
  getResoureceAvaialbleDashboard(query?) {
    let url = this.jobunittypecount + "?";
    if (query?.fromDate) {
      url = url + "fromDate=" + query.fromDate + '&';
    }
    if (query?.toDate) {
      url = url + "toDate=" + query.toDate + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getResourceSummary(id, query?) {
    let url = this.joburl + "/unitytypesummary/" + id + "?";
    if (query?.fromDate) {
      url = url + "fromDate=" + query.fromDate + '&';
    }
    if (query?.toDate) {
      url = url + "toDate=" + query.toDate + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCarrierDriverDashboard() {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(this.jobdrivercarrierloadcount , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  createDispatch(obj){
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(this.dispatchUrl, obj, options).pipe(
      map((response) => response.json()),
      catchError((error: Response) => {
        try {
          const err:any = error.json(); // Parses the JSON body
          console.error('Error Message:', err.message);
          return throwError(err);
        } catch (e) {
          return throwError({ message: 'An unknown error occurred.' });
        }
      })
    );
  }

  getDispatch(obj) {
    // obj {
/*     job: '67b9b7d768b71183781a3663',
    jobName: '11947 - 323 Campus Dr - ARVIN',
    load: '',
    loadId: '',
    status: '',
    customer: '',
    customerName: '',
    deliveryLocation: '',
    fromDate: '',
    toDate: '',
    costGroup: '',
    driverName: '',
    driver: '',
    perPage: 10,
    page: 1,
    sortKey: 'endDate',
    interplant: '',
    jobStatus: '',
    carrierId: '',
    carrierName: '',
    truckNo: '',
    truckId: '',
    unitType: ''
  } */
    let url = this.dispatchUrl + "?";
    if (obj?.job) {
      url = url + "jobId=" + obj.job + '&';
    }
    if (obj?.jobName) {
      url = url + "jobName=" + obj.jobName + '&';
    }
    if (obj?.load) {
      url = url + "loadNumber=" + obj.load + '&';
    }
    if (obj?.loadId) {
      url = url + "loadId=" + obj.loadId + '&';
    }
    if (obj?.status) {
      url = url + "status=" + obj.status + '&';
    }
    if (obj?.customer) {
      url = url + "customer=" + obj.customer + '&';
    }
    if (obj?.customerName) {
      url = url + "customerName=" + obj.customerName + '&';
    }
    if (obj?.deliveryLocation) {
      url = url + "deliveryLocation=" + obj.deliveryLocation + '&';
    }
    if (obj?.fromDate) {
      url = url + "fromDate=" + obj.fromDate + '&';
    }
    if (obj?.toDate) {
      url = url + "toDate=" + obj.toDate + '&';
    }
    if (obj?.costGroup) {
      url = url + "costGroup=" + obj.costGroup + '&';
    }
    if (obj?.driver) {
      url = url + "driver=" + obj.driver + '&';
    }
    if(obj?.carrierId){
      url = url + "carrier=" + obj.carrierId + '&';
    }
    if(obj?.truckId){
      url = url + "truck=" + obj.truckId + '&';
    }
    if(obj?.unitType){
      url = url + "unitType=" + obj.unitType + '&';
    }
    if(obj?.sortKey){
      url = url + "sortField=" + obj.sortKey + '&';
    }
    if(obj?.sortOrder){
      url = url + "sortOrder=" + obj.sortOrder + '&';
    }
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get( url, options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getDispatchById(id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(`${this.dispatchUrl}/${id}` , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateDispatchById(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(`${this.dispatchUrl}`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getTickets(obj) {
    let url = this.ticketUrl + "?";
    if (obj?.jobId) {
      url = url + "jobId=" + obj.jobId + '&';
    }
    if (obj?.customerId){
      url = url + "customerId=" + obj.customerId + '&';
    }
    if (obj?.driver){
      url = url + "driver=" + obj.driver + '&';
    }
    if (obj?.carrierId){
      url = url + "carrier=" + obj.carrier + '&';
    }
    if (obj?.truck){
      url = url + "truck=" + obj.truck + '&';
    }
    if (obj?.unitType){
      url = url + "unitType=" + obj.unitType + '&';
    }
    if( obj?.fromDate){
      url = url + "fromDate=" + obj.fromDate + '&';
    }
    if( obj?.toDate){
      url = url + "toDate=" + obj.toDate + '&';
    }
    if(obj?.pageNumber){
      url = url + "pageNumber=" + obj.pageNumber + '&';
    }
    if(obj?.pageSize){
      url = url + "pageSize=" + obj.pageSize + '&';
    }
    if(obj?.sortKey){
      url = url + "sortField=" + obj.sortKey + '&';
    }
    if(obj?.sortOrder){
      url = url + "sortOrder=" + obj.sortOrder + '&';
    }
    if(obj?.loadStatus){
      url = url + "status=" + obj.loadStatus + '&';
    }
    if(obj?.ticketId){
      url = url + "ticketId=" + obj.ticketId + '&';
    }
    if(obj?.ticketNumber){
      url = url + "ticketNumber=" + obj.ticketNumber + '&';
    }

    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getCompletedTickets(obj) {
    let url = this.ticketUrl + "/completed-ticket" + "?";
    if (obj?.jobId) {
      url = url + "jobId=" + obj.jobId + '&';
    }
    if (obj?.customerId){
      url = url + "customerId=" + obj.customerId + '&';
    }
    if (obj?.driver){
      url = url + "driver=" + obj.driver + '&';
    }
    if (obj?.carrierId){
      url = url + "carrier=" + obj.carrier + '&';
    }
    if (obj?.truck){
      url = url + "truck=" + obj.truck + '&';
    }
    if (obj?.unitType){
      url = url + "unitType=" + obj.unitType + '&';
    }
    if( obj?.fromDate){
      url = url + "fromDate=" + obj.fromDate + '&';
    }
    if( obj?.toDate){
      url = url + "toDate=" + obj.toDate + '&';
    }
    if(obj?.pageNumber){
      url = url + "pageNumber=" + obj.pageNumber + '&';
    }
    if(obj?.pageSize){
      url = url + "pageSize=" + obj.pageSize + '&';
    }
    if(obj?.sortKey){
      url = url + "sortField=" + obj.sortKey + '&';
    }
    if(obj?.sortOrder){
      url = url + "sortOrder=" + obj.sortOrder + '&';
    }
    if(obj?.loadStatus){
      url = url + "status=" + obj.loadStatus + '&';
    }
    if(obj?.ticketId){
      url = url + "ticketId=" + obj.ticketId + '&';
    }
    if(obj?.ticketNumber){
      url = url + "ticketNumber=" + obj.ticketNumber + '&';
    }

    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getTicketById(id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(`${this.ticketUrl}/${id}` , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getTicketLoadsByTicketId(ticketIds) {
    let url = `${this.ticketUrl}/ticket-loads`;
    if (!ticketIds || ticketIds.length === 0) {
      return observableThrowError('No ticket IDs provided');
    }
    url += '?ticketIds=' + ticketIds.join(',');
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });

    return this.http.get( url, options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }

  updateBulkDispatchById(obj,id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(`${this.dispatchUrl}/${id}/updateTickets`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  updateTicketId(obj,id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.put(`${this.ticketUrl}/${id}`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  addTicketId(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(`${this.ticketUrl}`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  sendDispatchMessage(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(`${this.dispatchUrl}/message`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  sendDispatchCustomMessage(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(`${this.dispatchUrl}/custom-message`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  sendDispatchAttachmentsMessage(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(`${this.dispatchUrl}/attachment-message`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  sendDispatchDetailsEmail(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(`${this.dispatchUrl}/attachment-email`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  cancelTicket(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(`${this.ticketUrl}/cancel-ticket`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }


  getInvoices(obj) {
    let url = this.jobInvoiceUrl + "?";
    if (obj?.jobId) {
      url = url + "jobId=" + obj.jobId + '&';
    }
    if (obj?.customerId){
      url = url + "customerId=" + obj.customerId + '&';
    }
    if (obj?.driver){
      url = url + "driver=" + obj.driver + '&';
    }
    if (obj?.carrierId){
      url = url + "carrier=" + obj.carrier + '&';
    }
    if (obj?.truck){
      url = url + "truck=" + obj.truck + '&';
    }
    if (obj?.unitType){
      url = url + "unitType=" + obj.unitType + '&';
    }
    if( obj?.fromDate){
      url = url + "fromDate=" + obj.fromDate + '&';
    }
    if( obj?.toDate){
      url = url + "toDate=" + obj.toDate + '&';
    }
    if(obj?.pageNumber){
      url = url + "pageNumber=" + obj.pageNumber + '&';
    }
    if(obj?.pageSize){
      url = url + "pageSize=" + obj.pageSize + '&';
    }
    if(obj?.sortKey){
      url = url + "sortField=" + obj.sortKey + '&';
    }
    if(obj?.sortOrder){
      url = url + "sortOrder=" + obj.sortOrder + '&';
    }
    if(obj?.status){
      url = url + "status=" + obj.status + '&';
    }
    if(obj?.ticketId){
      url = url + "ticketId=" + obj.ticketId + '&';
    }
    if( obj?.invoiceNumber){
      url = url + "invoiceNumber=" + obj.invoiceNumber + '&';
    }
    if(obj?.isCancelled){
      url = url + "isCancelled=" + obj.isCancelled + '&';
    }

    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(url, options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  getInvoicesById(id) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.get(`${this.jobInvoiceUrl}/${id}` , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
  sendInvoiceEmail(obj) {
    let options = new RequestOptions({
      headers: this._headerService.getHeader(),
    });
    return this.http.post(`${this.jobInvoiceUrl}/send-email`, obj , options).pipe(
      map((response:any) => response.json()),
      catchError((error: Response) => {
        return observableThrowError(error);
      })
    );
  }
}
// function observableThrowError(error: Response): any {
//   throw new Error('Function not implemented.');
// }

